import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { adminService } from '../../services/adminService';
import { ArrowLeft } from 'lucide-react';

const AdminFakeProfileEditPage = () => {
  const { dummyId } = useParams();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({ display_name: '', city: '', avatar_url: '', bio: '', hide_profile: false });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!dummyId) return;
    adminService.getUser(dummyId).then((data) => {
      setProfile(data);
      if (data) {
        setForm({
          display_name: data.display_name || '',
          city: data.city || '',
          avatar_url: data.avatar_url || '',
          bio: data.bio || '',
          hide_profile: !!data.hide_profile,
        });
      }
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [dummyId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!dummyId) return;
    setSaving(true);
    try {
      await adminService.updateDummyProfile(dummyId, form);
      setProfile((p) => (p ? { ...p, ...form } : p));
    } catch (err) {
      console.error(err);
    }
    setSaving(false);
  };

  if (loading || !profile) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-primary border-t-transparent" />
      </div>
    );
  }

  return (
    <div>
      <button
        type="button"
        onClick={() => navigate('/admin/fake-profiles')}
        className="flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-4"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to fake profiles
      </button>
      <h1 className="font-heading font-bold text-2xl text-slate-900 mb-6">Edit dummy profile</h1>
      <form onSubmit={handleSubmit} className="max-w-lg space-y-4">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Display name</label>
          <input
            type="text"
            value={form.display_name}
            onChange={(e) => setForm((f) => ({ ...f, display_name: e.target.value }))}
            className="w-full px-4 py-2 rounded-xl border border-slate-300 text-slate-800"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">City</label>
          <input
            type="text"
            value={form.city}
            onChange={(e) => setForm((f) => ({ ...f, city: e.target.value }))}
            className="w-full px-4 py-2 rounded-xl border border-slate-300 text-slate-800"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Avatar URL</label>
          <input
            type="url"
            value={form.avatar_url}
            onChange={(e) => setForm((f) => ({ ...f, avatar_url: e.target.value }))}
            className="w-full px-4 py-2 rounded-xl border border-slate-300 text-slate-800"
            placeholder="https://..."
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Bio</label>
          <textarea
            value={form.bio}
            onChange={(e) => setForm((f) => ({ ...f, bio: e.target.value }))}
            rows={3}
            className="w-full px-4 py-2 rounded-xl border border-slate-300 text-slate-800"
          />
        </div>
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={form.hide_profile}
            onChange={(e) => setForm((f) => ({ ...f, hide_profile: e.target.checked }))}
            className="rounded text-primary"
          />
          Hide profile (disable in discovery)
        </label>
        <button type="submit" disabled={saving} className="px-6 py-2 rounded-xl bg-primary text-white font-medium disabled:opacity-50">
          {saving ? 'Saving...' : 'Save'}
        </button>
      </form>
    </div>
  );
};

export default AdminFakeProfileEditPage;
